import { RadioGroup } from '@headlessui/react';
import { AiFillCheckCircle } from 'react-icons/ai';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const Roles = ({ roles, defaultRole, setFieldValue }) => {
    const { t } = useTranslation();

    const onChangeRole = (value) => setFieldValue('role_id', value.id);

    return (
        <RadioGroup value={defaultRole} onChange={onChangeRole} className="col-span-6">

            <div className="mt-4 flex flex-col gap-4">
                {roles.map((role) => (
                    <RadioGroup.Option
                        key={role.id}
                        value={role}
                        className={({ checked }) => classNames(checked ? 'bg-indigo-50 rounded-lg shadow-sm' : 'bg-gray-50 rounded-lg bg-opacity-60', 'relative flex cursor-pointer bg-white p-4 focus:outline-none')}
                    >
                        {({ checked }) => (
                            <span className="flex flex-1">
                                <span className="flex flex-col">
                                    <RadioGroup.Label as="span" className="block text-sm font-medium text-gray-900 capitalize">
                                        {role.name}
                                    </RadioGroup.Label>
                                    <RadioGroup.Description as="span" className="mt-1 flex items-center text-sm text-gray-500">
                                        {t(`${role.name}.description`)}
                                    </RadioGroup.Description>
                                    <AiFillCheckCircle className={classNames(!checked ? 'invisible' : '', 'absolute right-3 top-3 h-5 w-5 text-indigo-600')} />
                                </span>
                            </span>
                        )}
                    </RadioGroup.Option>
                ))}
            </div>
        </RadioGroup>
    );
};
